import React from 'react'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Tooltip from '@material-ui/core/Tooltip'

interface Props {
  onRequestSort
  columns
  order
  orderBy
}

class EnhancedTableHead extends React.PureComponent<Props> {
  private createSortHandler = (sortable: boolean, property: string) => {
    const noop = (): void => {}
    if (!sortable) {
      return noop
    }

    const sortHandler = (event): void => {
      this.props.onRequestSort(event, property)
    }
    return sortHandler
  }

  public render(): React.ReactNode {
    const { order, orderBy, columns } = this.props

    return (
      <TableHead>
        <TableRow>
          {columns.map(
            (column): React.ReactNode => (
              <TableCell
                key={column.id}
                align="left"
                sortDirection={orderBy === column.id ? order : false}
                style={{ minWidth: 50 }}
              >
                <TableSortLabel
                  active={orderBy === column.id}
                  direction={order}
                  onClick={this.createSortHandler(column.sortable, column.id)}
                >
                  {column.label}
                </TableSortLabel>
              </TableCell>
            ),
            this,
          )}
        </TableRow>
      </TableHead>
    )
  }
}

export default EnhancedTableHead
